import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesShowcase() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <p className="font-heading text-xs md:text-sm uppercase tracking-widest text-primary-600 font-semibold mb-3">
            Shopping Guides & Articles
          </p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Sugargoo Spreadsheet Resources
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Explore our collection of in-depth guides covering everything from beginner tutorials to advanced shopping strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 overflow-hidden transition-all duration-200 cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-[16/10]">
                <img
                  src={article.thumbnailImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  title={article.title}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-200"></div>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full font-medium">Guide</span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-700 transition-colors line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">
                  {article.description}
                </p>
                <div className="mt-3 pt-3 border-t border-background-100 flex items-center gap-1.5 text-xs text-primary-600 font-medium">
                  Read Article <i className="ri-arrow-right-line text-[10px]"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}